import React from "react";

import 'url-search-params-polyfill';

import AddSentenceToCollectionBtn from "../AddSentenceToCollectionBtn";
import ChunkProgressBar from "../Dashboard/ChunkProgressBar";
import ClozeSentence from "../ClozeSentence";
import CollectionClozeSentenceEditorModal from "../CollectionClozeSentenceEditorModal";
import DailyGoalStats from "../DailyGoalStats";
import V5DailyReminderPrompt from "./V5DailyReminderPrompt";
import DiscussionBtn from "../DiscussionBtn";
import FlagSprite from "../FlagSprite";
import Icon from "../Icon";
import Panel from "../Panel";
import ProSubscribeModal from "../ProSubscribeModal";
import StreakSaveEarnedModal from "../StreakSaves/StreakSaveEarnedModal";
import StreakSaveIntroModal from "../StreakSaves/StreakSaveIntroModal";
import ReportErrorBtn from "./ReportErrorBtn";
import TeachingCollectionResultsForm from "./TeachingCollectionResultsForm";
import Tokens from "./Tokens";

import LanguagePairingDropdown from "../LanguagePairingDropdown";

import { pctStr, ordinalSuffix } from "../../helpers";
import { trackAmplitudeEvent } from "../../amplitude";
import { addExtraNewWords, buildPlayUrl, buildQueue, freeCardsRemainingToday, isComplete, nextInQueue, resolveConfig, todayString } from "../TodaysPlan/todaysPlanService";
import { Confetti, TodaysPlanCelebrationModal, TodaysPlanCompleteRow, TodaysPlanInProgressRow } from "../TodaysPlan/TodaysPlanRoundResults";
import { fetchTodaysPlanSettings, localKey, readLocal, readTodaysExtraNewWords, writeLocal } from "../TodaysPlan/todaysPlanStorage";

class RoundResultsCollectionClozeSentenceTableRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      controlsVisible: false,
      sentenceEditorModalVisible: false
    };
  }

  componentDidMount() {
    $("body").popover({
      container: "body",
      selector: ".collection-progress [data-toggle=popover]"
    });
  }

  renderFavoriteBtn() {
    const { collectionClozeSentence, isPro, updateSentence, updating } = this.props;

    if(!isPro) {
      return (
        <button disabled={updating} className="btn btn-default favorite" title="Favorite sentence" data-toggle="modal" data-target="#favorite-pro-promo-modal" title="Toggle favorite">
          <Icon name="star-empty" />
        </button>
      );
    }

    return (
      <button
        className={'btn btn-default favorite' + (collectionClozeSentence.favorited ? ' active' : '')}
        disabled={updating}
        onClick={() => updateSentence('favorited', !collectionClozeSentence.favorited)}
        title="Toggle favorite"
      >
        <span className={'glyphicon glyphicon-star' + (collectionClozeSentence.favorited ? '' : '-empty')}></span>
      </button>
    );
  }

  renderAudioBtn() {
    const { collectionClozeSentence, isTtsAvailable, playTts, updating } = this.props;

    if(!isTtsAvailable(collectionClozeSentence)) {
      return null;
    }

    return (
      <button disabled={updating} className="btn btn-default audio" onClick={() => playTts({ sentence: collectionClozeSentence })} title="Play sentence audio">
        <Icon name="volume-up" />
      </button>
    );
  }

  renderControls() {
    const {
      baseLanguageEnglishName,
      collectionClozeSentence,
      collectionsUrl,
      isPro,
      isReportable,
      isSignedIn,
      nextReviewByLevel,
      reportErrorUrl,
      targetLanguageEnglishName,
      targetLanguageName,
      updateSentence,
      updating
    } = this.props;

    if(!isSignedIn) {
      return null;
    }

    return (
      <div className="sentence-controls">
        <div className="btn-group btn-group-sm" role="group" aria-label="Sentence controls">
          {this.renderAudioBtn()}
          <button disabled={updating} className="btn btn-default edit-sentence" onClick={() => this.setState({ sentenceEditorModalVisible: true })} title="Edit sentence">
            <Icon name="pencil" />
          </button>
          {this.renderFavoriteBtn()}
          <button
            className={'btn btn-default ignore' + (collectionClozeSentence.ignored ? ' active' : '')}
            disabled={updating}
            onClick={() => updateSentence('ignored', !collectionClozeSentence.ignored)}
            title="Toggle ignore"
          >
            <Icon name="ban-circle" />
          </button>
        </div>
        {' '}
        <div className="btn-group btn-group-sm" role="group" aria-label="More sentence controls">
          {this.renderTokensBtn()}
          <AddSentenceToCollectionBtn
            className="btn btn-default add-sentence-to-collection"
            collectionClozeSentence={collectionClozeSentence}
            collectionsUrl={collectionsUrl}
            copyable={true}
            isPro={isPro}
            nextReviewByLevel={nextReviewByLevel}
            text={false}
            title="Add sentence to collection"
          />
          <DiscussionBtn
            baseLanguageEnglishName={baseLanguageEnglishName}
            className="btn btn-default discussion"
            clozeSentence={collectionClozeSentence}
            disabled={updating}
            isPro={isPro}
            targetLanguageEnglishName={targetLanguageEnglishName}
            targetLanguageName={targetLanguageName}
            title="Discussion"
          />
          {isReportable && (
            <ReportErrorBtn
              className="btn btn-default report-error"
              collectionClozeSentence={collectionClozeSentence}
              disabled={updating}
              title="Report error"
              url={collectionClozeSentence.collectionClozeSentencesErrorUrl || reportErrorUrl}
            />
          )}
        </div>
      </div>
    );
  }

  renderSentenceEditorModal() {
    if(!this.state.sentenceEditorModalVisible) {
      return null;
    }

    const {
      collectionClozeSentence,
      collectionClozeSentencesUpsertUrl,
      isPro,
      isTextEditable,
      nextReviewByLevel,
      onUpdate,
    } = this.props;

    return (
      <CollectionClozeSentenceEditorModal
        isPro={isPro}
        isTextEditable={isTextEditable}
        nextReviewByLevel={nextReviewByLevel}
        onHidden={() => this.setState({ sentenceEditorModalVisible: false })}
        onUpdate={(sentence) => onUpdate(sentence)}
        ref={(el) => this.sentenceEditorModal = el}
        sentence={collectionClozeSentence}
        upsertUrl={collectionClozeSentence.collectionClozeSentencesUpsertUrl || collectionClozeSentencesUpsertUrl}
      />
    );
  }

  renderTokensBtn() {
    const { collectionClozeSentence } = this.props;

    if(!collectionClozeSentence.tokensCount) {
      return null;
    }

    const { tokensVisible } = this.state;
    const { updateHasShownTokens } = this.props;

    return (
      <button className="btn btn-default toggle-tokens" onClick={() => this.setState({ tokensVisible: !tokensVisible }, () => { this.hasShownTokens && updateHasShownTokens(); this.hasShownTokens = true })} title="Toggle grammar">
        <Icon name={`chevron-${tokensVisible ? "up" : "down"}`} />
      </button>
    );
  }

  renderTokens() {
    if(!this.state.tokensVisible) {
      return null;
    }

    const {
      collectionClozeSentence,
      hasShownTokens,
      isPro,
      targetLanguageCode,
      targetLanguageIso,
      tokensUrl
    } = this.props;

    if(!isPro && hasShownTokens) {
      return (
        <div className="alert alert-success text-center" style={{ clear: "both", margin: "10px 0 5px" }}>
          <p style={{ fontWeight: "bold", marginBottom: 10 }}>Get full access to sentence grammar with Clozemaster Pro - subscribe today and get fluent faster!</p>
          <p><a className="btn btn-success joystix" href="/pro">Get Pro!</a></p>
        </div>
      );
    }

    return (
      <div className="scrollbar-always-visible" style={{ overflowY: "scroll", textAlign: "center", whiteSpace: "nowrap", width: "100%" }}>
        <Tokens
          targetLanguageCode={targetLanguageCode}
          targetLanguageIso={targetLanguageIso}
          tokenizeableId={collectionClozeSentence.id}
          tokenizeableType={"CollectionClozeSentence"}
          url={tokensUrl || collectionClozeSentence.tokensUrl}
        />
      </div>
    );
  }

  render() {
    const { collectionClozeSentence } = this.props;
    const { controlsVisible } = this.state;

    return (
      <div className="round-result-sentence">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontSize: '2rem' }}>
              <ClozeSentence text={collectionClozeSentence.text} />
            </div>
            {this.renderTokens()}
            <div className="text-secondary"><small>{collectionClozeSentence.translation}</small></div>
          </div>
          <button className="btn btn-default toggle-sentence-controls" style={{ marginLeft: 12, flexShrink: 0 }} onClick={() => this.setState({ controlsVisible: !controlsVisible })}>
            <Icon name={`chevron-${controlsVisible ? "up" : "down"}`} />
          </button>
        </div>
        {controlsVisible && this.renderControls()}
        {this.renderSentenceEditorModal()}
      </div>
    );
  }
}

export default class RoundResults extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collectionClozeSentences: props.collectionClozeSentences,
      loadingLanguagePairingStats: true,
      loadingTodaysPlan: this.isTodaysPlanSession(),
      todaysPlan: null
    };
  }

  componentDidMount() {
    this.props.playSoundEffect();

    // After a redo nothing was saved, so there's no round to report and nothing new
    // to celebrate - but the stats are still loaded (a read) because the bottom bar's
    // "continue normally" button depends on what's left to review.
    if(this.props.redoMode) {
      if(this.props.isSignedIn) {
        this.loadLanguagePairingStats();
      }
      this.loadTodaysPlan();
      return;
    }

    trackAmplitudeEvent("web_app_hit_round_results", Object.assign(
      {},
      this.props.amplitudeRoundProperties || {},
      {
        // Zero outside full text input, where nothing retries. num_gave_up / num_retried
        // is the read on whether exact-match grading is fair; num_submits over the
        // sentences played gives attempts-to-correct. elapsed_time carries seconds per
        // sentence, which matters because Translate is 3-5x slower than text input and
        // that collides with review throughput.
        elapsed_time: this.props.elapsedTime,
        num_correct: this.props.numCorrect,
        num_gave_up: this.props.roundNumGaveUp,
        num_incorrect: this.props.numIncorrect,
        num_mastered: this.props.numMastered,
        num_new: this.props.numNew,
        num_retried: this.props.roundNumRetried,
        num_review: this.props.numReview,
        num_submits: this.props.roundNumSubmits,
        score: this.props.score
      }
    ));

    if(this.props.isSignedIn) {
      this.loadLanguagePairingStats();
    }

    this.loadTodaysPlan();
  }

  isTodaysPlanSession() {
    return new URLSearchParams(window.location.search).get("todays_plan") === "1";
  }

  // Rebuilt from fresh progress like the app, so an item a round didn't finish plays again.
  loadTodaysPlan() {
    if(!this.isTodaysPlanSession()) {
      return;
    }

    $.ajax({ url: this.props.languagePairingUrl })
      .done(({ collections, languagePairing, user }) => {
        fetchTodaysPlanSettings(languagePairing.todaysPlanSettingsUrl)
          .then((savedConfig) => this.showTodaysPlan({ collections, languagePairing, savedConfig, username: user && user.username }))
          .catch(() => this.stopLoadingTodaysPlan());
      })
      .fail(() => this.stopLoadingTodaysPlan());
  }

  // Without the saved plan, guessing one could send Keep Playing to a turned-off collection, so only Dashboard is offered.
  stopLoadingTodaysPlan() {
    this.setState({ loadingTodaysPlan: false }, () => this.runPendingPrimaryAction());
  }

  runPendingPrimaryAction() {
    if(this.pendingPrimaryAction) {
      this.pendingPrimaryAction = false;
      this.triggerPrimaryAction();
    }
  }

  showTodaysPlan({ collections, languagePairing, savedConfig, username }) {
    const { isPro, redoMode, targetLanguageCode, targetLanguageIso } = this.props;
    const { extra } = readTodaysExtraNewWords(username, languagePairing.id);
    const config = addExtraNewWords(resolveConfig(collections, languagePairing.playOptions, savedConfig), collections, extra);
    const queue = buildQueue(collections, config, {
      isPro,
      isSpeakingAvailable: !!(window.clozemaster.speechRecognition.isSupported(targetLanguageIso) && window.clozemaster.speechRecognition.isAvailable()),
      isSystemTtsAvailable: !!window.clozemaster.systemTtsAvailable(targetLanguageIso, targetLanguageCode)
    });
    const isPlanComplete = !redoMode && isComplete(queue);
    const todaysPlan = {
      collections,
      completedItems: queue.reduce((s, item) => s + item.completed, 0),
      freeCardsRemaining: isPro ? 0 : freeCardsRemainingToday(collections),
      isCelebrating: isPlanComplete && this.claimTodaysPlanCelebration(username, languagePairing.id),
      isComplete: isPlanComplete,
      daysPlayed: languagePairing.showDaysPlayedInsteadOfStreak ? languagePairing.daysPlayedCount : 0,
      queue,
      streakDays: languagePairing.showDaysPlayedInsteadOfStreak ? 0 : languagePairing.currentStreakDays,
      totalItems: queue.reduce((s, item) => s + item.total, 0)
    };

    // Claimed once a day like the celebration, so a refresh or a later round does not count it again.
    if(todaysPlan.isCelebrating) {
      trackAmplitudeEvent("todays_plan_completed", {
        time_spent_seconds: this.props.elapsedTime,
        total_rounds_played: queue.filter((item) => item.completed >= item.total).length
      });
      trackAmplitudeEvent("todays_plan_celebration_viewed", {
        completed_items: todaysPlan.completedItems,
        current_streak_length: languagePairing.currentStreakDays,
        language: targetLanguageCode,
        total_items: todaysPlan.totalItems
      });
    }

    this.setState({ loadingTodaysPlan: false, todaysPlan }, () => this.runPendingPrimaryAction());
  }

  // Like the app, the plan celebration comes before the other end-of-round pop-ups.
  isTodaysPlanCelebrating() {
    const { todaysPlan } = this.state;
    return this.isTodaysPlanSession() && !!todaysPlan && !!todaysPlan.isCelebrating;
  }

  claimTodaysPlanCelebration(username, languagePairingId) {
    const key = localKey("CelebrationShown", username, languagePairingId);
    if(readLocal(key) === todayString()) {
      return false;
    }
    writeLocal(key, todayString());
    return true;
  }

  loadLanguagePairingStats() {
    this.setState({ loadingLanguagePairingStats: true });

    const data = this.isReviewScope() ? {} : { collection_id: this.props.collectionId };

    $.ajax({
      data: { ...data, include_cefr: true, include_celebrations: !this.props.redoMode },
      url: this.props.languagePairingUrl
    })
      .done((data) => {
        console.log('loadLanguagePairingStats', data);

        const {
          baseLanguageFlagIso,
          currentLevelPoints,
          currentWeekLeaderboardRank,
          dailyGoalHoursLeftToday,
          dailyGoalPointsPerDay,
          dailyGoalStreak,
          daysPlayedCount,
          level,
          nextLevelPoints,
          numPointsToday,
          pointsToNextCurrentWeekLeaderboardRank,
          prevWeekLeaderboardRank,
          progressPerChunk,
          score,
          showDaysPlayedInsteadOfStreak,
          shouldCelebrateEarn,
          shouldCelebrateIntro,
          streakSaveBalance,
          currentStreakDays,
          targetLanguageFlagIso,
          useProgressChunks
        } = data.languagePairing;

        const collectionsReadyForReview = data.collections.filter((c) => c.numReadyForReview > 0);

        let collectionState = {};
        if(this.props.collectionId) {
          const collection = data.collections.find((c) => c.id === this.props.collectionId);
          collectionState = {
            collectionName: collection.name,
            collectionNumMastered: collection.numMastered,
            collectionNumPlaying: collection.numPlaying,
            collectionNumReadyForReview: collection.numReadyForReview,
            collectionNumSentences: collection.numSentences,
            collectionSlug: collection.slug,
            nextCollectionToReview: collectionsReadyForReview[0] && collectionsReadyForReview[0].slug,
          };
        }

        this.setState(Object.assign(collectionState, {
          baseLanguageFlagIso,
          collectionsReadyForReview,
          currentLevelPoints,
          currentStreakDays,
          currentWeekLeaderboardRank,
          dailyGoalHoursLeftToday,
          dailyGoalPointsPerDay,
          dailyGoalStreak,
          daysPlayedCount,
          level,
          loadingLanguagePairingStats: false,
          nextLevelPoints,
          numPointsToday,
          pointsToNextCurrentWeekLeaderboardRank,
          prevWeekLeaderboardRank,
          progressPerChunk,
          score,
          showDaysPlayedInsteadOfStreak,
          streakSaveBalance,
          streakSaveCelebrationsAcknowledgeUrl: data.languagePairing.streakSaveCelebrationsAcknowledgeUrl,
          streakSaveEarnedVisible: !!shouldCelebrateEarn,
          streakSaveIntroVisible: !!shouldCelebrateIntro,
          targetLanguageFlagIso,
          useProgressChunks
        }), () => {
          // Enter/space pressed before the stats came back -- run whatever the
          // bottom bar's primary button ended up being instead of dropping it.
          if(this.pendingPrimaryAction) {
            this.pendingPrimaryAction = false;
            this.triggerPrimaryAction();
          }
        });
      })
      .fail(() => {
        this.pendingPrimaryAction = false;
        alert('Oh no! There was an error loading the latest stats. Sorry about that. Please let us know if you see this message again.');
      });
  }

  renderStats() {
    const { elapsedTime, isTeachingCollection, numCorrect, numIncorrect, numNew, numReview, redoMode, score } = this.props;
    return (
      <div>
        <h2 className="v5-section-heading">Stats</h2>
        <div className="panel panel-default">
          <div className="panel-body" style={{ padding: 0 }}>
            <table className="table stats" style={{ marginBottom: 0 }}>
              <tbody><tr>
                  {!redoMode && (
                    <td className="score">
                      <span className="stat text-secondary">Points earned:</span> <span className="value">+{score}</span>
                    </td>
                  )}
                  <td className="time" colSpan={redoMode ? 2 : null}>
                    <span className="stat text-secondary">Time spent:</span> <span className="value">{Math.floor(elapsedTime / 60)}:{elapsedTime % 60 < 10 ? '0' : ''}{elapsedTime % 60}</span>
                  </td>
                </tr>
                {!isTeachingCollection && !redoMode && (
                  <tr>
                    <td className="new">
                      <span className="stat text-secondary">New:</span> <span className="value">{numNew}</span>
                    </td>
                    <td className="review">
                      <span className="stat text-secondary">Review:</span> <span className="value">{numReview}</span>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="correct">
                    <span className="stat text-secondary">Correct:</span> <span className="value">{numCorrect}</span>
                  </td>
                  <td className="incorrect">
                    <span className="stat text-secondary">Incorrect:</span> <span className="value">{numIncorrect}</span>
                  </td>
                </tr>
            </tbody></table>
          </div>
        </div>
      </div>
    );
  }

  isTranslateReviewsSession() {
    return new URLSearchParams(window.location.search).get("translate_reviews") === "1";
  }

  todaysPlanNext() {
    const { todaysPlan } = this.state;
    const nextItem = todaysPlan && nextInQueue(todaysPlan.queue);
    const nextCollection = nextItem && todaysPlan.collections.find((c) => String(c.id) === nextItem.collectionId);
    return nextCollection ? { nextCollection, nextItem } : null;
  }

  renderTodaysPlanRow() {
    const { collectionClozeSentences, todaysPlan } = this.state;
    if(!todaysPlan) {
      return null;
    }

    const next = this.todaysPlanNext();
    if(next) {
      return (
        <TodaysPlanInProgressRow
          collectionName={next.nextCollection.name}
          isTranslateReviewsEnabled={this.isTranslateReviewsSession()}
          nextItem={next.nextItem}
          queue={todaysPlan.queue}
          roundSentenceCount={(collectionClozeSentences || []).length}
        />
      );
    }

    return todaysPlan.isComplete ? <TodaysPlanCompleteRow freeCardsRemaining={todaysPlan.freeCardsRemaining} /> : null;
  }

  renderTodaysPlanCelebration() {
    const { todaysPlan } = this.state;
    if(!todaysPlan || !todaysPlan.isComplete) {
      return null;
    }

    return (
      <>
        <Confetti />
        {todaysPlan.isCelebrating && (
          <TodaysPlanCelebrationModal
            completedItems={todaysPlan.completedItems}
            daysPlayed={todaysPlan.daysPlayed}
            onHidden={() => this.setState({ todaysPlan: { ...todaysPlan, isCelebrating: false } })}
            streakDays={todaysPlan.streakDays}
          />
        )}
      </>
    );
  }

  renderTodaysPlanNextUp() {
    const { loadingTodaysPlan, todaysPlan } = this.state;

    if(loadingTodaysPlan) {
      return <button className="btn btn-success joystix btn-lg v5-keep-playing-btn" disabled>Keep Playing</button>;
    }

    const next = this.todaysPlanNext();
    if(!next) {
      return (
        <a className="btn btn-success joystix btn-lg v5-keep-playing-btn" data-testid="todays-plan-dashboard" href={this.getDashboardPath()}>
          <Icon name="arrow-left" /> Dashboard
        </a>
      );
    }

    const { nextCollection, nextItem } = next;
    const url = buildPlayUrl(nextCollection, nextItem, { isTranslateReviewsEnabled: this.isTranslateReviewsSession() });
    const remainingItems = todaysPlan.queue.filter((item) => item.completed < item.total);
    const playedCollection = todaysPlan.collections.find((c) => c.id === this.props.collectionId);
    const trackLoopContinued = () => trackAmplitudeEvent("todays_plan_loop_continued", {
      completed_collection_name: playedCollection ? playedCollection.name : null,
      next_collection_name: nextCollection.name,
      remaining_collections_in_loop: remainingItems.length
    });

    this.primaryAction = () => {
      trackLoopContinued();
      window.location.href = url;
    };

    return (
      <a className="btn btn-success joystix btn-lg v5-keep-playing-btn" data-testid="todays-plan-keep-playing" href={url} onClick={trackLoopContinued}>
        Keep Playing
      </a>
    );
  }

  goToNextCollectionToReview() {
    window.location = window.location.toString().replace('collections/' + this.state.collectionSlug, 'collections/' + this.state.nextCollectionToReview);
  }

  getDashboardPath() {
    const { isPro, languagePairingWebUrl, onboarding } = this.props;
    return onboarding && !isPro ? "/welcome-pro" : (languagePairingWebUrl || "/dashboard");
  }

  // Called by the parent play component when enter/space/right arrow is pressed
  // on the round results screen so the keyboard shortcut does whatever the
  // primary green button on the bottom bar does.
  triggerPrimaryAction() {
    if(typeof this.primaryAction === "function") {
      this.primaryAction();
      return true;
    }

    // Still waiting on the stats that determine which button we show -- run
    // the action as soon as we know what it is.
    if((this.props.isSignedIn && this.state.loadingLanguagePairingStats) || this.state.loadingTodaysPlan) {
      this.pendingPrimaryAction = true;
      return true;
    }

    return false;
  }

  renderBottomBar() {
    let bar;

    // Set by each branch below to the bottom bar's primary (green) button
    // action, or left null when there isn't one (e.g. only a Dashboard link).
    this.primaryAction = null;

    if(this.isTodaysPlanSession()) {
      bar = (
        <>
          {this.renderTodaysPlanNextUp()}
        </>
      );
    }
    else if(this.props.isTeachingCollection) {
      this.primaryAction = () => this.props.onNextRound();

      bar = (
        <>
          <a className="btn btn-success joystix btn-lg v5-keep-playing-btn" href="">
            Keep Playing!
          </a>
        </>
      );
    }
    else if(!this.isReviewScope() || this.state.loadingLanguagePairingStats) {
      const disabled = this.props.isSignedIn && this.state.loadingLanguagePairingStats;

      if(!disabled) {
        this.primaryAction = () => this.props.onNextRound();
      }

      bar = (
        <>
          <button className="btn btn-success joystix btn-lg v5-keep-playing-btn" disabled={disabled} onClick={this.props.onNextRound}>
            Keep Playing!
          </button>
        </>
      );
    }
    else {
      const { collectionNumReadyForReview, collectionsReadyForReview, nextCollectionToReview } = this.state;

      if(collectionNumReadyForReview) {
        this.primaryAction = () => this.props.onNextRound();

        bar = (
          <>
            <button className="btn btn-success joystix btn-lg v5-keep-playing-btn" onClick={this.props.onNextRound}>
              Keep Playing! ({collectionNumReadyForReview})
            </button>
          </>
        );
      }
      else if(!this.props.collectionId && collectionsReadyForReview.length) {
        this.primaryAction = () => this.props.onNextRound();

        bar = (
          <>
            <button className="btn btn-success joystix btn-lg v5-keep-playing-btn" onClick={this.props.onNextRound}>
              Keep Playing! ({collectionsReadyForReview.reduce((total, c) => total + c.numReadyForReview, 0)})
            </button>
          </>
        );
      }
      else if(collectionsReadyForReview.length) {
        this.primaryAction = () => this.goToNextCollectionToReview();

        bar = (
          <>
            <button className="btn btn-success joystix btn-lg v5-keep-playing-btn" onClick={() => this.goToNextCollectionToReview()}>
              Review Next Collection!
            </button>
            <select name="next_collection_to_review" className="form-control input-lg" value={nextCollectionToReview} onChange={(e) => this.setState({ nextCollectionToReview: e.target.value })} style={{ marginTop: 10 }}>
              {collectionsReadyForReview.map((c) => (
                <option key={c.id} value={c.slug}>{c.name} ({c.numReadyForReview})</option>
              ))}
            </select>
          </>
        );
      }
      else {
        bar = (
          <>
            <div className="text-center joystix" style={{ marginBottom: 8 }}>No more sentences ready for review! &#x1f64c;</div>
            <a className="btn btn-default joystix btn-block btn-lg" href={this.getDashboardPath()}>
              Dashboard
            </a>
          </>
        );
      }
    }

    return (
      <div className="v5-bottom-bar">
        {bar}
        {this.renderRedoRoundBtn()}
      </div>
    );
  }

  // Deliberately quiet - a link under the primary button, not a second CTA.
  renderRedoRoundBtn() {
    if(!this.props.redoable) {
      return null;
    }

    return (
      <div>
        <button className="btn btn-link btn-sm v5-redo-round-btn" onClick={() => this.props.onRedoRound()} title="Shortcut: alt+r">
          <Icon name="repeat" /> {this.props.redoMode ? "Redo again" : "Redo this round"}
        </button>
        <small className="text-secondary v5-redo-round-hint">Practice the same sentences again &mdash; won&apos;t change your progress or reviews</small>
      </div>
    );
  }

  renderDailyGoal() {
    const { dailyGoalHoursLeftToday, numPointsToday, dailyGoalPointsPerDay, dailyGoalStreak, loadingLanguagePairingStats } = this.state;

    if(loadingLanguagePairingStats) {
      return null;
    }

    if(!dailyGoalPointsPerDay) {
      return null;
    }

    return (
      <div>
        <h2 className="v5-section-heading">Daily Goal</h2>
        <div className="panel panel-default">
          <div className="panel-body">
            <DailyGoalStats
              hoursLeftToday={dailyGoalHoursLeftToday}
              numPointsToday={numPointsToday}
              pointsPerDay={dailyGoalPointsPerDay}
              streak={dailyGoalStreak}
              style={{ display: 'inline-block' }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderCollectionProgress() {
    if(!this.props.collectionId) {
      return null;
    }

    const {
      startingNumMastered,
      startingNumPlaying,
      startingNumReadyForReview
    } = this.props;

    const {
      collectionName,
      collectionNumMastered,
      collectionNumPlaying,
      collectionNumReadyForReview,
      collectionNumSentences,
      progressPerChunk,
      useProgressChunks
    } = this.state;

    const numMasteredDiff = collectionNumMastered - startingNumMastered;
    const numPlayingDiff = collectionNumPlaying - startingNumPlaying;
    const numReadyForReviewDiff = collectionNumReadyForReview - startingNumReadyForReview;
    const pctMastered = pctStr(collectionNumMastered, collectionNumSentences);
    const pctPlaying = pctStr(collectionNumPlaying, collectionNumSentences);

    return (
      <div className="panel panel-default collection-progress">
        <div className="panel-heading joystix">{collectionName}</div>
        <div className="panel-body">
          <div className="collection-progress-grid">
            <div>
              <div className="text-secondary">Playing:</div>
              <span className="joystix">
                {collectionNumPlaying.toLocaleString()} / {collectionNumSentences.toLocaleString()}
                {numPlayingDiff > 0 ? <span className="stat-change">+{numPlayingDiff}</span> : null}
              </span>
              <br />
              {numPlayingDiff > 0 ? <>{pctStr(startingNumPlaying, collectionNumSentences)}<span style={{ marginLeft: 4, marginRight: 4 }}><Icon name="arrow-right" /></span></> : null}
              {pctPlaying}
              {!!useProgressChunks && (
                <ChunkProgressBar
                  includePopoverHelperBtn={true}
                  num={collectionNumPlaying}
                  pct={pctPlaying}
                  perChunk={progressPerChunk}
                  style={{ marginTop: 2 }}
                  total={collectionNumSentences}
                  type="playing"
                />
              )}
            </div>
            <div>
              <div className="text-secondary">Mastered:</div>
              <span className="joystix">
                {collectionNumMastered.toLocaleString()} / {collectionNumSentences.toLocaleString()}
                {numMasteredDiff > 0 ? <span className="stat-change">+{numMasteredDiff}</span> : null}
              </span>
              <br />
              {numMasteredDiff > 0 ? <>{pctStr(startingNumMastered, collectionNumSentences)}<span style={{ marginLeft: 4, marginRight: 4 }}><Icon name="arrow-right" /></span></> : null}
              {pctMastered}
              {!!useProgressChunks && (
                <ChunkProgressBar
                  num={collectionNumMastered}
                  pct={pctMastered}
                  perChunk={progressPerChunk}
                  style={{ marginTop: 2 }}
                  total={collectionNumSentences}
                  type="mastered"
                />
              )}
            </div>
            <div>
              <div className="text-secondary">Ready for Review:</div>
              <span className="joystix">
                {collectionNumReadyForReview}
                {numReadyForReviewDiff > 0 ? <span className="stat-change">-{numReadyForReviewDiff}</span> : null}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLeveledUpIndicator() {
    if(this.props.leveledUp) {
      // up arrow, tada, hands raised
      return (
        <span className="leveled-up-indicator" style={{ color: "#5cb85c", paddingLeft: 10 }}>
          &#x2b06;&#x1f389;&#x1f64c;
        </span>
      );
    }
  }

  renderProgress() {
    const {
      baseLanguageFlagIso,
      currentLevelPoints,
      currentWeekLeaderboardRank,
      level,
      loadingLanguagePairingStats,
      nextLevelPoints,
      pointsToNextCurrentWeekLeaderboardRank,
      prevWeekLeaderboardRank,
      score,
      targetLanguageFlagIso
    } = this.state;

    if(loadingLanguagePairingStats) {
      return null;
    }

    let rankExtra = null;
    if(currentWeekLeaderboardRank === 1) {
      rankExtra = <span style={{ marginLeft: 6 }}>&#x1F3C6;</span>;
    }
    else if(currentWeekLeaderboardRank && currentWeekLeaderboardRank > 1 && pointsToNextCurrentWeekLeaderboardRank) {
      const nextRank = currentWeekLeaderboardRank - 1;
      rankExtra = <small><br />({pointsToNextCurrentWeekLeaderboardRank.toLocaleString()} points to {nextRank}<sup>{ordinalSuffix(nextRank)}</sup>)</small>;
    }

    let prevWeekRank = null;
    if(prevWeekLeaderboardRank) {
      const up = currentWeekLeaderboardRank > prevWeekLeaderboardRank;
      // <LeaderboardRankTrend />
      prevWeekRank = (
        <span data-toggle="tooltip" title={'Ranked ' + prevWeekLeaderboardRank + ' last week'}>
          <Icon name={'arrow-' + (up ? 'up' : 'down')} />
        </span>
      );
    }

    return (
      <div>
        <h2 className="v5-section-heading">Progress</h2>
        {this.renderCollectionProgress()}
        <div className="panel panel-default">
          <div className="panel-heading joystix">
            <FlagSprite flagIso={targetLanguageFlagIso} size={24} /> / <FlagSprite flagIso={baseLanguageFlagIso} size={24} />
          </div>
          <div className="panel-body">
            <div>
              <span className="joystix">Level: {level}{this.renderLeveledUpIndicator()}</span>
              <br />
              <div className="progress" style={{ height: 10, marginBottom: 4 }}>
                <div aria-valuemax="100" aria-valuemin="0" className="progress-bar progress-bar-success" role="progressbar" style={{ width: ((score - currentLevelPoints) / (nextLevelPoints - currentLevelPoints) * 100) + '%' }}></div>
              </div>
              {(nextLevelPoints - score).toLocaleString()} points to level {level + 1} - keep going!
            </div>
            {!!currentWeekLeaderboardRank && (
              <>
                <hr />
                <div>
                  <span className="joystix">Ranked: {currentWeekLeaderboardRank}<sup>{ordinalSuffix(currentWeekLeaderboardRank)}</sup>{prevWeekRank} this week</span>
                  {rankExtra}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderProPromo() {
    if((this.props.shouldUseFreeLeftTodayPromo && !this.props.isPro && !!this.props.maxPlayableToday) || !this.props.isSignedIn || this.props.isPro) {
      return null;
    }

    return (
      <div className="panel panel-default" style={{ marginTop: 20 }}>
        <div className="panel-body">
          <p className="text-center" style={{ fontSize: '1.5em' }}>Get fluent <em>even</em> faster.</p>
          <a href="/pro" className="btn btn-block btn-lg btn-success pro-promo joystix">
            Get <span className="hidden-xs">Clozemaster Pro</span> <span className="glyphicon glyphicon-chevron-right"></span>
          </a>
        </div>
      </div>
    );
  }

  renderFreeLeftTodayProPromo() {
    const { shouldUseFreeLeftTodayPromo, maxPlayableToday, numPlayedToday, numNew, numReview } = this.props;

    if (!shouldUseFreeLeftTodayPromo || !this.props.maxPlayableToday || this.props.isPro) {
      return null;
    }

    const played = numPlayedToday;
    const remaining = Math.max(0, maxPlayableToday - played);
    const pctUsed = Math.min(100, Math.round(played / maxPlayableToday * 100));
    const reachedLimit = remaining === 0;

    return (
      <div>
        <h2 className="v5-section-heading">Get fluent <em>even</em> faster</h2>
        <div className="panel panel-default">
          <div className="panel-body">
            <div style={{ marginBottom: 15 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span className="text-secondary">{played} / {maxPlayableToday} free sentences today</span>
                <span className="joystix" style={{ fontSize: "0.85em" }}>{reachedLimit ? "0 left" : `${remaining} left`}</span>
              </div>
              <div className="progress" style={{ height: 10, marginBottom: 0 }}>
                <div
                  className={`progress-bar ${pctUsed >= 80 ? "progress-bar-warning" : "progress-bar-success"}`}
                  role="progressbar"
                  style={{ width: pctUsed + "%" }}
                />
              </div>
            </div>
            {reachedLimit ? (
              <div style={{ fontSize: "1.1em", marginBottom: 15, textAlign: "center" }}>
                <p style={{ marginBottom: 8 }}>
                  You've played all <strong>{maxPlayableToday}</strong> free sentences for today! 🙌
                </p>
                <p style={{ marginBottom: 0 }}>
                  Upgrade to Pro for <strong>unlimited daily sentences</strong> and much more. 🚀
                </p>
              </div>
            ) : (
              <p style={{ fontSize: "1.1em", marginBottom: 15 }}>
                You have <strong>{remaining}</strong> free sentence{remaining !== 1 ? "s" : ""} left today. Go Pro for unlimited sentences, listening & speaking practice, detailed stats, and more.
              </p>
            )}
            <ProSubscribeModal
              paddleConfigUrl="/api/v1/users/paddle_config"
              buttonClass="btn btn-success btn-block btn-lg joystix"
              buttonText={reachedLimit ? "Go Pro - Keep Playing!" : "Learn more"}
              showBenefits={true}
              onSubscribed={({ isPro }) => {
                if (isPro) window.location.reload();
              }}
            />
            {reachedLimit && (
              <p className="text-center text-secondary" style={{ marginTop: 12, marginBottom: 0 }}>
                Or come back tomorrow for {maxPlayableToday} more free sentences.
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderSignUpPromo() {
    if(this.props.isSignedIn) {
      return null;
    }

    let message = "Save your progress!";

    if(this.props.isTeachingCollection) {
      message = "Get fluent faster with Clozemaster!";
    }

    return (
      <div className="panel panel-default" style={{ marginTop: 20 }}>
        <div className="panel-body">
          <p className="text-center" style={{ fontSize: '1.5em' }}>{message}</p>
          <a href="/pro" className="btn btn-block btn-lg btn-success joystix">
            Sign Up <span className="glyphicon glyphicon-chevron-right"></span>
          </a>
        </div>
      </div>
    );
  }

  renderTeachingCollectionResultsForm() {
    if(!this.props.isTeachingCollection) {
      return null;
    }

    const params = new URLSearchParams(window.location.search);
    if(params.get("results") === "false") {
      return null;
    }

    const { answerTape, elapsedTime, numCorrect, numIncorrect, score } = this.props;
    const stats = { answerTape, elapsedTime, numCorrect, numIncorrect, score };

    return (
      <Panel>
        <TeachingCollectionResultsForm
          stats={stats}
          teachingCollectionResultsUrl={this.props.teachingCollectionResultsUrl}
        />
      </Panel>
    );
  }

  mergeUpdatedCollectionClozeSentence(collectionClozeSentence) {
    const collectionClozeSentences = JSON.parse(JSON.stringify(this.state.collectionClozeSentences));
    for(let i = 0, n = collectionClozeSentences.length; i < n; i++) {
      if(collectionClozeSentences[i].id === collectionClozeSentence.id) {
        collectionClozeSentences[i] = collectionClozeSentence;
        break;
      }
    }
    this.setState({ collectionClozeSentences });
  }

  renderSentences() {
    const { collectionClozeSentences } = this.state;

    const sentences = collectionClozeSentences.map((ccs) => (
      <RoundResultsCollectionClozeSentenceTableRow
        baseLanguageEnglishName={this.props.baseLanguageEnglishName}
        collectionClozeSentence={ccs}
        collectionClozeSentencesUpsertUrl={this.props.collectionClozeSentencesUpsertUrl}
        collectionsUrl={this.props.collectionsUrl}
        hasShownTokens={this.props.hasShownTokens}
        isPro={this.props.isPro}
        isReportable={!this.props.isCollectionEditable}
        isSignedIn={this.props.isSignedIn}
        isTextEditable={this.props.isCollectionEditable}
        isTtsAvailable={this.props.isTtsAvailable}
        key={ccs.id}
        nextReviewByLevel={this.props.nextReviewByLevel}
        updateHasShownTokens={this.props.updateHasShownTokens}
        onUpdate={(collectionClozeSentence) => this.mergeUpdatedCollectionClozeSentence(collectionClozeSentence)}
        playTts={this.props.playTts}
        reportErrorUrl={this.props.reportErrorUrl}
        targetLanguageCode={this.props.targetLanguageCode}
        targetLanguageEnglishName={this.props.targetLanguageEnglishName}
        targetLanguageIso={this.props.targetLanguageIso}
        targetLanguageName={this.props.targetLanguageName}
        tokensUrl={this.props.tokensUrl}
        updateSentence={(attr, value) => {
          this.props.updateSentence({
            sentence: ccs,
            attr,
            value,
            callback: () => {
              ccs[attr] = value;
              this.mergeUpdatedCollectionClozeSentence(ccs);
            }
          });
        }}
        update={this.props.updating}
      />
    ));

    return (
      <div>
        <h2 className="v5-section-heading">Sentences</h2>
        <div className="panel panel-default">
          <div className="panel-body round-result-sentences">
            {sentences}
          </div>
        </div>
      </div>
    );
  }

  isReviewScope() {
    return this.props.scope === 'ready_for_review';
  }

  renderUpdates() {
    const {
      numMastered,
      numNew,
      numReview,
      targetLanguageEnglishName
    } = this.props;

    const updates = [];
    if (numNew > 0) {
      updates.push({
        count: numNew,
        emoji: "🚀",
        label: "new sentences",
        title: "Your vocabulary is growing!",
      });
    }

    if (numReview > 0) {
      updates.push({
        count: numReview,
        emoji: "💪",
        label: "sentences reviewed",
        title: "Your fluency is increasing!",
      });
    }

    if (numMastered > 0) {
      updates.push({
        count: numMastered,
        emoji: "🎉",
        label: "sentences mastered",
        title: `You're mastering ${targetLanguageEnglishName}!`,
      });
    }

    if (updates.length === 0) {
      return null;
    }

    return (
      <Panel>
        {updates.map((update, index) => (
          <div className="v5-round-complete-update">
            <div className="update-emoji">{update.emoji}</div>
            <div className="update-content">
              <div className="update-title">{update.title}</div>
              <div className="update-secondary text-secondary">
                <span className="update-count">+{update.count}</span> {update.label}
              </div>
            </div>
          </div>
        ))}
      </Panel>
    );
  }

  renderDailyReminderPrompt() {
    if(!this.props.dailyReminderWithSentenceEnabled) {
      return null;
    }
    if(!this.props.isSignedIn) {
      return null;
    }
    if(this.props.dailyReminderEmail) {
      return null;
    }
    if(!this.props.dailyReminderEmailUrl) {
      return null;
    }
    if(this.state.loadingLanguagePairingStats) {
      return null;
    }

    return (
      <V5DailyReminderPrompt
        amplitudeRoundProperties={this.props.amplitudeRoundProperties}
        dailyReminderEmail={this.props.dailyReminderEmail}
        isSignedIn={this.props.isSignedIn}
        showDaysPlayedInsteadOfStreak={this.state.showDaysPlayedInsteadOfStreak}
        timeZone={this.props.timeZone}
        updateUrl={this.props.dailyReminderEmailUrl}
      />
    );
  }

  renderRedo() {
    return (
      <div className="done round-complete v5-round-results" style={{ display: "block" }}>
        <div>
          <a className="btn btn-default joystix btn-sm" href={this.getDashboardPath()} title="Dashboard">
            <Icon name="chevron-left" /> Dashboard
          </a>
        </div>
        <h1 className="joystix text-center v5-round-complete-heading">
          <span style={{ display: "block", fontSize: "6rem", paddingBottom: 10 }}>🔁</span>
          Replay Complete!
        </h1>
        <div className="container-fluid v5-round-complete-content">
          <p className="text-center text-secondary v5-redo-results-note">
            This was a practice replay, so your progress, points and review schedule are unchanged.
          </p>
          {this.renderStats()}
          {this.renderSentences()}
        </div>
        {this.renderBottomBar()}
      </div>
    );
  }

  render() {
    if(this.props.redoMode) {
      return this.renderRedo();
    }

    return (
      <div className="done round-complete v5-round-results" style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <a href={this.getDashboardPath()} className="btn btn-default joystix btn-sm" title="Dashboard">
            <Icon name="chevron-left" /> Dashboard
          </a>
          {this.props.languagePairings && this.props.languagePairings.length > 1 && (
            <LanguagePairingDropdown
              baseLanguageFlagIso={this.props.baseLanguageFlagIso}
              buttonClassName="btn btn-default dropdown-toggle"
              languagePairings={this.props.languagePairings}
              targetLanguageFlagIso={this.props.targetLanguageFlagIso}
              targetLanguageName={this.props.targetLanguageName}
            />
          )}
        </div>
        <h1 className="joystix text-center v5-round-complete-heading">
          <span style={{ display: "block", fontSize: "6rem", paddingBottom: 10 }}>🙌</span>
          Round Complete!
        </h1>
        <div className="container-fluid v5-round-complete-content">
          {this.isTodaysPlanSession() && this.renderTodaysPlanRow()}
          {this.renderUpdates()}
          {this.renderStats()}
          {this.renderProPromo()}
          {this.renderFreeLeftTodayProPromo()}
          {this.renderSignUpPromo()}
          {this.renderTeachingCollectionResultsForm()}
          {this.renderDailyReminderPrompt()}
          {this.renderDailyGoal()}
          {this.renderProgress()}
          {this.renderSentences()}
        </div>
        {this.renderBottomBar()}
        {this.isTodaysPlanSession() && this.renderTodaysPlanCelebration()}
        {this.state.streakSaveIntroVisible && !this.isTodaysPlanCelebrating() && (
          <StreakSaveIntroModal
            currentStreakDays={this.state.currentStreakDays}
            streakSaveBalance={this.state.streakSaveBalance}
            ackUrl={this.state.streakSaveCelebrationsAcknowledgeUrl}
            onHidden={() => this.setState({ streakSaveIntroVisible: false })}
          />
        )}
        {this.state.streakSaveEarnedVisible && !this.isTodaysPlanCelebrating() && (
          <StreakSaveEarnedModal
            currentStreakDays={this.state.currentStreakDays}
            streakSaveBalance={this.state.streakSaveBalance}
            ackUrl={this.state.streakSaveCelebrationsAcknowledgeUrl}
            onHidden={() => this.setState({ streakSaveEarnedVisible: false })}
          />
        )}
      </div>
    );
  }
}
